import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class InventoryControlOffOnNonEmptyInventoryLevel extends Violation {
    public constructor() {
        super(ViolationSeverity.Warning, 'business.product.validation.inventory-control.off-on-non-empty-inventory-level-warning');
    }
}
